export const GET_INVESTMENT_COLLECTION = 'GET_INVESTMENT_COLLECTION'
export const SET_INVESTMENT_COLLECTION_FILTER =
  'SET_INVESTMENT_COLLECTION_FILTER'

export const FETCH_INVESTMENT_DATA = 'FETCH_INVESTMENT_DATA'

export type InvestmentColectionActions =
  | {
      type: typeof GET_INVESTMENT_COLLECTION
      payload: string
    }
  | {
      type: typeof SET_INVESTMENT_COLLECTION_FILTER
      payload: {
        params: string
        name: string
        currentCity: string
      }
    }
  | {
      type: typeof FETCH_INVESTMENT_DATA
      payload: string
    }

export interface InvestmentsColectionState {
  buyAndRent: InvestmentsColectionType
  buyAndSell: InvestmentsColectionType
  saveYourSavings: InvestmentsColectionType
}

type InvestmentsColectionType = {
  filter: string
  chartData: []
  chartType: string
  units: string
  fixType: boolean
  currentCity: string
}
